import { arrayMove } from '@dnd-kit/sortable';
import { CollectionsListState, CollectionsListUpdateParams } from '@src/types/Collection';

export function getNextCollectionsListState({
  currentList,
  activeId,
  overId,
  overType,
  sourceCategory,
  destinationCategory,
}: CollectionsListUpdateParams): { didUpdate: boolean; nextList: CollectionsListState } {
  const next = currentList.map((category) => ({
    name: category.name,
    list: [...category.list],
  }));

  const sourceEntry = next.find((category) => category.name === sourceCategory);
  const destinationEntry = next.find((category) => category.name === destinationCategory);

  if (!sourceEntry || !destinationEntry) {
    return { didUpdate: false, nextList: currentList };
  }

  const sourceIndex = sourceEntry.list.indexOf(activeId);
  if (sourceIndex === -1) {
    return { didUpdate: false, nextList: currentList };
  }

  if (sourceCategory === destinationCategory) {
    const isDroppingIntoContainer = overType === 'category-container' || overId === destinationCategory;
    if (!isDroppingIntoContainer && overId === activeId) {
      return { didUpdate: false, nextList: currentList };
    }
    const targetIndex = isDroppingIntoContainer
      ? sourceEntry.list.length - 1
      : sourceEntry.list.indexOf(overId ?? '');
    if (targetIndex === -1 || targetIndex === sourceIndex) {
      return { didUpdate: false, nextList: currentList };
    }
    sourceEntry.list = arrayMove(sourceEntry.list, sourceIndex, targetIndex);
  } else {
    const [removed] = sourceEntry.list.splice(sourceIndex, 1);
    const destinationIndex =
      overType === 'category-container' || !overId || overId === destinationCategory
        ? destinationEntry.list.length
        : destinationEntry.list.indexOf(overId);
    const insertIndex = destinationIndex === -1 ? destinationEntry.list.length : destinationIndex;
    destinationEntry.list.splice(insertIndex, 0, removed);
  }

  return { didUpdate: true, nextList: next };
}
